import { render, staticRenderFns } from "./ExtraAttrs.vue?vue&type=template&id=5bc3efcc&scoped=true&"
import script from "./ExtraAttrs.vue?vue&type=script&lang=js&"
export * from "./ExtraAttrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3efcc",
  null
  
)

export default component.exports